import { useState, useRef } from 'react';
import HeadContext from './head-context';
import buildMeta from './build-meta';
import config from '../../config'
import { useNavigator } from '../navigator'

export const HeadProvider = ({ serverProps, children }) => {
	const [data, setData] = useState({ ...config?.head?.defaultHead ?? {}, ...serverProps?.head ?? {} });
	const { getRoutePath } = useNavigator();

	const headChangedTimeout = useRef(false);
	const headChanged = useRef(false);

	const [renderedData, setRenderedData] = useState(buildMeta(data, serverProps.pathname ?? undefined, getRoutePath));

	const renderHeadTags = (tags) => {
		let oldTags = document.head.querySelectorAll('*[data-custom-meta]');
		for (let k = 0; k < oldTags.length; k++) {
			document.head.removeChild(oldTags[k]);
		}

		for (const customData of tags) {
			if(customData.key === 'title') {
				document.title = customData.content;
			}
			else {
				let customObj = document.createElement(customData.key);
				if (customData.content) { customObj.innerHTML = customData.content }
	
				let customProps = Object.keys(customData.props);
	
				for (let p = 0; p < customProps.length; p++) {
					let propKey = customProps[p];
					let propVal = customData.props[propKey]
					if(propKey === "property" || propKey === "name"){
						let oldTag = document.head.querySelector(customData.key+'['+propKey+'="'+propVal+'"]');
						if(oldTag){
							document.head.removeChild(oldTag)
						}
					}
	
					customObj.setAttribute(propKey, propVal);
				}
				customObj.setAttribute('data-custom-meta', 'true');
				document.head.appendChild(customObj);
			}
		}
	}

	const setHead = (headData, clear = true, base = false) => {
		const newHeadData = {
			...config.head.defaultHead,
			...(clear ? {} : data),
			...headData
		};

		setData(newHeadData);
		const newRenderedData = buildMeta(newHeadData, undefined, getRoutePath);
		setRenderedData(newRenderedData);
		renderHeadTags(newRenderedData);

		if(!base) {
			headChanged.current = true;
			if(headChangedTimeout.current) {
				clearTimeout(headChangedTimeout.current);
			}

			headChangedTimeout.current = setTimeout(() => {
				headChanged.current = false;
				headChangedTimeout.current = false;
			}, 500);
		}
	}

	const setBaseHead = (headData) => {
		if(!headChanged.current) {
			setHead(headData, true, true);
		}
	}

	return (
		<HeadContext.Provider value={{
			data,
			renderedData,
			setHead,
			setBaseHead,
		}}>
			{children}
		</HeadContext.Provider>
	)
}

export default HeadProvider;